if (!customElements.get("variant-accessibility-confirmation")) {
  customElements.define(
    "variant-accessibility-confirmation",
    class VariantAccessibilityConfirmation extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.section = this.closest("section");
        this.selectedVariantId = String(this.dataset.selectedVariantId || "");
        this.section?.addEventListener("variantChangeEnd", (event) => {
          const picker = event.target.closest("variant-options") || event.target;
          const variantId = picker.currentVariant?.id || picker.dataset.variantId;
          if (variantId) this.updateForVariant(String(variantId));
        });
        this.updateForVariant(this.selectedVariantId);
      }

      updateForVariant(variantId) {
        this.selectedVariantId = String(variantId);
        this.dataset.selectedVariantId = this.selectedVariantId;
        this.querySelectorAll("[data-accessibility-confirmation-for]").forEach((notice) => {
          notice.hidden = notice.dataset.accessibilityConfirmationFor !== this.selectedVariantId;
        });
      }

      confirmAndApply(form) {
        form?.querySelector("[data-accessibility-confirmation-property]")?.remove();
        const notice = this.querySelector(
          `[data-accessibility-confirmation-for="${CSS.escape(this.selectedVariantId)}"]`
        );
        if (!notice || notice.dataset.accessibilityRequired !== "true") return true;

        const message =
          notice.dataset.accessibilityMessage ||
          "Please check accessibility into your room of choice for this item.";
        const accepted = window.confirm(
          `${message}\n\nPlease select OK to confirm that you have checked access into the room of choice.`
        );
        if (!accepted) return false;

        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "properties[Room accessibility]";
        input.value = `Confirmed — ${message}`;
        input.dataset.accessibilityConfirmationProperty = "true";
        form.appendChild(input);
        return true;
      }
    }
  );
}
